import gsap from 'gsap';
import { createScrollTrigger } from 'scripts/lib/gsap/scrollTrigger';
import { Breakpoints } from 'common/views/appBreakpoints';

// Breakpoints.resizeEvent.on(() => ScrollTrigger.refresh());
Breakpoints.Current.breakpointChanged.on(() => window.location.reload());

export const CreateExitAnimation = (fromELement: HTMLElement, toElement: HTMLElement, animation?: gsap.core.Timeline) => {
    const createTimeline = () => gsap.timeline()
        .fromTo(fromELement, { y: 0 }, { y: 140, duration: 1 });


    return createScrollTrigger({
        trigger: toElement,
        start: 'top bottom',
        end: 'top top',
        scrub: true,
        pinSpacing: false,
        pin: fromELement,
        animation: animation || createTimeline(),
    });
};
